"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Responsive = _interopRequireDefault(require("@active/react-utils/components/Responsive"));
var _Dropdown = _interopRequireDefault(require("../Dropdown"));
var _NativeDropdown = _interopRequireDefault(require("../NativeDropdown"));
var _excluded = ["onChange"];
var ResponsiveDropdown = function ResponsiveDropdown(_ref, ref) {
  var onChange = _ref.onChange,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Responsive["default"], {
    eqAbove: "md"
  }, /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], (0, _extends2["default"])({}, props, {
    onChange: onChange,
    ref: ref
  }))), /*#__PURE__*/_react["default"].createElement(_Responsive["default"], {
    not: true,
    eqAbove: "md"
  }, /*#__PURE__*/_react["default"].createElement(_NativeDropdown["default"], (0, _extends2["default"])({}, props, {
    onChange: onChange,
    ref: ref
  }))));
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(ResponsiveDropdown);